function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0345 7.10847C16.3435 7.41746 16.3673 7.90366 16.1058 8.23991L16.0345 8.32066L7.46309 16.8921C7.15411 17.2011 6.66791 17.2248 6.33166 16.9634L6.25091 16.8921L2.82234 13.4635C2.48761 13.1288 2.48761 12.5861 2.82234 12.2513C3.13133 11.9423 3.61752 11.9186 3.95377 12.18L4.03452 12.2513L6.857 15.0731L14.8223 7.10847C15.1571 6.77374 15.6998 6.77374 16.0345 7.10847ZM21.1774 7.10847C21.4864 7.41746 21.5101 7.90366 21.2487 8.23991L21.1774 8.32066L12.606 16.8921C12.2712 17.2268 11.7285 17.2268 11.3938 16.8921C11.0848 16.5831 11.061 16.0969 11.3225 15.7606L11.3938 15.6799L19.9652 7.10847C20.2999 6.77374 20.8426 6.77374 21.1774 7.10847Z",
  fill: "#32D74B"
});

function SvgIconCheckGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreen);
export default __webpack_public_path__ + "assets/media/icon-check-green.b92a4d9a.svg";
export { ForwardRef as ReactComponent };